module.exports = __webpack_public_path__ + "img/3.65905b40.jpg";